import React from "react";

const Dashboard = () => {
  return <div className="page-content">Dashboard</div>;
};

export default Dashboard;
